import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { UserListLastNameCell } from '@app/feature/user/user-list/user-list-last-name.cell';
import { UserListLastNameHeader } from '@app/feature/user/user-list/user-list-last-name.header';

export const CustomerUserListLastNameColumn: IdentifiedColumnDef<
  GatewayUserModel,
  GatewayUserModel['lastName']
> = {
  enableSorting: false,
  header: UserListLastNameHeader,
  cell: UserListLastNameCell,
};
